import $store from '@/store.js'
class UndoAction {
  constructor (data) {
    this.undoList = []
    this.NewPosition = 0
    this.MaxStep = data.MaxStep || 5 // 撤销最大步数
    this.undoStep = 0
    this.executeCommand = data.executeCommand || ''
    this.UndoType = data.UndoType || ''
    this.inputFirst = false
    this.monitorKey = this.monitorKey.bind(this)
  }

  init () {
    document.addEventListener('keydown', this.monitorKey)
  }

  monitorKey (e) {
    const UndoCurrentType = $store.state.playout && $store.state.playout.UndoCurrentType
    if ((UndoCurrentType && this.UndoType) && UndoCurrentType != this.UndoType) {
      return
    }
    const ctrlKey = (e.metaKey && !e.shiftKey)
    if ((e.ctrlKey && e.keyCode == 90) || (ctrlKey && e.keyCode == 90)) {
      e.preventDefault()
      this.undo()
    }
    const ctrlShiftKey = (e.metaKey && e.shiftKey)
    if ((e.ctrlKey && e.keyCode == 89) || (ctrlShiftKey && e.keyCode == 90)) {
      e.preventDefault()
      this.redo()
    }
  }

  undo () {
    // 第二步开始才可以撤回
    if (this.NewPosition > 1) {
      this.inputFirst = false
      this.NewPosition--
      this.executeCommand(this.undoList[this.NewPosition - 1])
    }
  }

  redo () {
    // 小于总步数才能重做
    if (this.NewPosition < this.undoStep) {
      this.NewPosition++
      this.executeCommand(this.undoList[this.NewPosition - 1])
    }
  }

  pushUndo (data, type) {
    const ActionData = JSON.parse(JSON.stringify(data))
    if (type == 'input' && !this.inputFirst) {
      this.inputFirst = true
    } else if (type && this.inputFirst) {
      this.undoList[this.NewPosition - 1] = ActionData
      if (type == 'inputEnd') {
        this.inputFirst = false
      }
      return
    } else {
      this.inputFirst = false
    }
    // 和上一步为同一步 补充上一步信息
    if (type == 'lastStep') {
      const lastStep = this.undoList[this.NewPosition - 1]
      this.undoList[this.NewPosition - 1] = {
        ...lastStep,
        ...ActionData
      }
      return
    }
    const diff = this.undoStep - this.NewPosition
    if (diff) {
      this.undoList.splice(this.NewPosition, diff)
      this.undoStep = this.NewPosition
    }
    if (this.undoStep > this.MaxStep) {
      this.undoList.shift()
      this.undoList.push(ActionData)
    } else {
      this.undoList.push(ActionData)
    }
    this.undoStep = this.NewPosition = this.undoList.length
  }

  clearUndo (data, type) {
    this.undoList = []
    this.undoStep = 0
    this.inputFirst = false
    if (data) {
      this.pushUndo(data, type)
    }
  }

  stop () {
    document.removeEventListener('keydown', this.monitorKey)
  }
}
export default UndoAction
